interface PalmerSectionLabelProps {
  left1: string;
  left2: string;
  right: string;
}

export default function PalmerSectionLabel({ left1, left2, right }: PalmerSectionLabelProps) {
  return (
    <div
      className="px-6 py-3 flex items-center justify-between border-b border-white/10 mb-10"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      <div className="flex items-center gap-4">
        <span className="text-white/30 text-xs">{left1}</span>
        <span className="text-white/20 text-xs">{left2}</span>
      </div>
      <span className="text-white/20 text-xs">{right}</span>
    </div>
  );
}
